if(!customElements.get('urevo-tabs')){
    class UrevoTab extends HTMLElement {
        constructor() {
            super()
            
        }
        connectedCallback() {
            setTimeout(() => {
                this.initEvents()
            }, 0);
        }
        initEvents() {
            this.tabCon = this
            this.tabHeader = this.querySelector('.ure-tabs-header')
            this.headerItems = this.querySelectorAll('.ure-tabs-header-item')
            this.contentItems = this.querySelectorAll('.ure-tabs-content-item')
            
            this.headerItems.forEach((headerItem, index) => {
                headerItem.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.headerItems.forEach(item => item.classList.remove('active'));
                    this.contentItems.forEach(item => item.classList.remove('active'));
                    headerItem.classList.add('active');
                    this.contentItems[index].classList.add('active');
                    if(window.innerWidth < 768) {
                        headerItem.scrollIntoView({ behavior: "smooth", inline: "center" });
                    }
                });
            })
        }
    }
    customElements.define('urevo-tabs', UrevoTab)    
}
